module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isTowerCo() && this.value && this.value > 0) ? _c('div', [_c('el-tooltip', {
    attrs: {
      "content": _vm.title,
      "placement": "top",
      "effect": "dark"
    }
  }, [(_vm.isDesktop) ? _c('el-badge', {
    attrs: {
      "value": _vm.value,
      "type": _vm.badgeColor()
    }
  }, [_c('i', {
    class: 'fa fa-' + this.icon
  })]) : _c('div', [_c('i', {
    class: 'fa fa-' + this.icon
  }), _vm._v(" "), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.value))])])], 1)], 1) : _c('div', [_c('el-tooltip', {
    attrs: {
      "content": _vm.title,
      "placement": "top",
      "effect": "dark"
    }
  }, [_c('i', {
    class: 'fa fa-' + this.icon
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-174693b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/SitesMenuBadge.vue
// module id = 1339
// module chunks = 0